import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';

import { TellentAssistantMobileService } from '@core/tellent-assistant-mobile-smart-ui';
import { injectDevFlagSignal } from '@core/tellent-dev-flags-logic';
import {
  TellentAdoptedStylesheetsDirective,
  TellentAppShellTopbarButtonComponent,
  TellentThemeDirective,
} from '@core/tellent-smart-ui';
import { TellentDevFlag, TellentWebComponent } from '@core/tellent-types';

// TEMPORARY: TellentAssistantMobileTriggerComponent's own button chrome doesn't render once
// wc-bridged into a non-Angular host (styles incompatible with the host page) — swap the visual
// for the already-working topbar-button chrome until a real design lands. `service` (not just
// `TellentAssistantControlService`) is injected so TellentAssistantMobileService's effects, which
// drive the presenter bridge to the host's sheet, actually get instantiated regardless of the
// flag below.
@Component({
  // NOTE: `makeTellentSelector` (defineCustomElements) turns the leading "x-" into "tellent-" —
  // it does NOT anchor the replace, so an "x-tellent-..." selector doubles up into
  // "tellent-tellent-...". Keep "tellent" out of this selector; the transform adds it.
  selector: 'x-assistant-mobile-trigger',
  templateUrl: './tellent-assistant-mobile-trigger.component.html',
  styleUrls: ['../../../styles.less'],
  styles: ':host { display: contents; }',
  hostDirectives: [TellentThemeDirective, TellentAdoptedStylesheetsDirective],
  imports: [TellentAppShellTopbarButtonComponent],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TellentAssistantMobileTriggerWrapComponent {
  protected readonly tellentAssistantFlag = injectDevFlagSignal(TellentDevFlag.TellentAssistant);
  protected readonly service = inject(TellentAssistantMobileService);
}

export type TellentAssistantMobileTriggerWebComponent = TellentWebComponent<
  TellentAssistantMobileTriggerWrapComponent,
  never
>;
